import Link from "next/link";
import { useForm } from "react-hook-form";
import { Button } from "@/components/Buttons";
import { HiddenField, ReadOnlyField, SelectField, TextAreaField } from "@/components/Form/Parts/index";
import { inquiryList } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import processStyles from "@/styles/Process.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function createOption(value, format) {
  return {
    value: value,
    label: format
  };
}
function inquiryOptions() {
  const options = [];
  for (const key in inquiryList) {
    options.push(createOption(key, inquiryList[key]));
  }
  return options;
}
export default function Step2(_ref) {
  let {
    onSubmit,
    pageBack,
    formData,
    user,
    privacypolicy,
    gip,
    ua
  } = _ref;
  const {
    register,
    handleSubmit,
    formState
  } = useForm({
    defaultValues: formData
  });
  return /*#__PURE__*/_jsxs("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: [/*#__PURE__*/_jsx("div", {
      className: processStyles.contentWrapper,
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.content,
        children: [/*#__PURE__*/_jsx("p", {
          className: `${processStyles.contentHeader} ${processStyles.mailForm}`,
          children: "\u4E0B\u8A18\u306E\u5185\u5BB9\u3092\u3054\u78BA\u8A8D\u306E\u3046\u3048\u300C\u9001\u4FE1\u300D\u30DC\u30BF\u30F3\u3092\u62BC\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsx("fieldset", {
          className: `${formStyles.basicFieldset} ${formStyles.marginOff}`,
          children: /*#__PURE__*/_jsx("div", {
            className: formStyles.inputField,
            children: /*#__PURE__*/_jsx("div", {
              className: formStyles.formGroup,
              children: /*#__PURE__*/_jsx(ReadOnlyField, {
                ref: register,
                name: "name",
                title: user ? "名前" : "名前（漢字、又はカナ）",
                value: (formData === null || formData === void 0 ? void 0 : formData.fullName) || (user === null || user === void 0 ? void 0 : user.fullName),
                required: true
              })
            })
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(ReadOnlyField, {
            ref: register,
            name: "mailAddress",
            value: formData === null || formData === void 0 ? void 0 : formData.mailAddress,
            title: "\u3054\u9023\u7D61\u53EF\u80FD\u306AE\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9",
            required: true
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(ReadOnlyField, {
            ref: register,
            name: "membersId",
            value: (formData === null || formData === void 0 ? void 0 : formData.membersId) || (user === null || user === void 0 ? void 0 : user.mailAddress) || "",
            title: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\uFF08\u3054\u767B\u9332\u306E\u65B9\u306E\u307F\uFF09"
          })
        }), /*#__PURE__*/_jsx("fieldset", {
          className: formStyles.basicFieldset,
          children: /*#__PURE__*/_jsx(ReadOnlyField, {
            ref: register,
            name: "pastSpooxId",
            value: (formData === null || formData === void 0 ? void 0 : formData.pastSpooxId) || "",
            title: "\u904E\u53BB\u3054\u767B\u9332\u306ESPOOX ID\uFF08\u3054\u767B\u9332\u306E\u65B9\u306E\u307F\uFF09"
          })
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(SelectField, {
            title: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9",
            options: inquiryOptions(),
            name: "commentOption",
            placeholder: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9",
            value: createOption(formData === null || formData === void 0 ? void 0 : formData.commentOption, inquiryList[formData === null || formData === void 0 ? void 0 : formData.commentOption]),
            isDisabled: true,
            required: true
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "commentOption",
            defaultValue: formData === null || formData === void 0 ? void 0 : formData.commentOption
          })]
        }), /*#__PURE__*/_jsxs("fieldset", {
          className: formStyles.basicFieldset,
          children: [/*#__PURE__*/_jsx(TextAreaField, {
            title: "\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u306E\u8A73\u7D30",
            name: "comment",
            placeholder: "\u30B3\u30E1\u30F3\u30C8",
            defaultValue: formData === null || formData === void 0 ? void 0 : formData.comment,
            readOnly: true,
            required: true,
            disabled: true
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "comment",
            defaultValue: formData === null || formData === void 0 ? void 0 : formData.comment
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "ua",
            defaultValue: ua
          }), /*#__PURE__*/_jsx(HiddenField, {
            ref: register,
            name: "gip",
            defaultValue: gip
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: formStyles.guideArea,
      children: [/*#__PURE__*/_jsx("p", {
        children: "\u4F7F\u7528\u3057\u3066\u3044\u308B\u7AEF\u672B\uFF08\u30D1\u30BD\u30B3\u30F3\u3001\u30B9\u30DE\u30FC\u30C8\u30D5\u30A9\u30F3\u3001\u30BF\u30D6\u30EC\u30C3\u30C8\u7B49\uFF09\u3084\u3001\u3054\u5229\u7528\u306E\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u74B0\u5883\u306A\u3069\u306E\u60C5\u5831\u3092\u6DFB\u3048\u3066\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u306E\u5185\u5BB9\u306F\u3067\u304D\u308B\u3060\u3051\u8A73\u3057\u304F\u304A\u66F8\u304D\u304F\u3060\u3055\u3044\u3002"
      }), /*#__PURE__*/_jsxs("ul", {
        children: [privacypolicy && /*#__PURE__*/_jsxs("li", {
          children: ["\u9001\u4FE1\u3044\u305F\u3060\u304F\u524D\u306B\u3001", /*#__PURE__*/_jsx(Link, {
            href: privacypolicy.url,
            target: "_blank",
            rel: "noopener noreferrer",
            className: formStyles.textLink,
            children: "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC"
          }), "\u306E\u5185\u5BB9\u3092\u5FC5\u305A\u304A\u8AAD\u307F\u304F\u3060\u3055\u3044\u3002\u307E\u305F\u304A\u5BA2\u69D8\u672C\u4EBA\u304C\u540C\u610F\u3057\u305F\u4E0A\u3067\u500B\u4EBA\u60C5\u5831\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002"]
        }), /*#__PURE__*/_jsx("li", {
          children: "\u56DE\u7B54\u306B\u6642\u9593\u304C\u304B\u304B\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u307E\u305F\u3001\u304A\u554F\u3044\u5408\u308F\u305B\u5185\u5BB9\u306B\u3088\u3063\u3066\u306F\u3054\u8FD4\u4FE1\u3067\u304D\u306A\u3044\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u3002\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002"
        }), /*#__PURE__*/_jsxs("li", {
          children: ["\u65E5\u672C\u8A9E\u4EE5\u5916\u306E\u304A\u554F\u3044\u5408\u308F\u305B\u306B\u306F\u304A\u5FDC\u3048\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002", /*#__PURE__*/_jsx("br", {}), "Please understand that all information is provided in Japanese only."]
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: `${formStyles.btnArea} ${formStyles.multiple} ${formStyles.minWidth10em}`,
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        onClick: pageBack,
        borderGray: true,
        fontFixed: true,
        children: "\u623B\u308B"
      }), /*#__PURE__*/_jsx(Button, {
        type: "submit",
        fillColor: true,
        fontFixed: true,
        loading: formState.isSubmitting,
        children: "\u9001\u4FE1"
      })]
    })]
  });
}